import { makeStyles } from "@material-ui/core/styles";

const useCommonStyles = makeStyles((theme) => ({
  container: {
    margin: theme.spacing(2),
    marginBottom: 0,
  },
  backButton: {
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  headerPaper: {
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  },
  headerTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  userIconContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  userIcon: {
    backgroundColor: "#e0e0e0",
    color: "#757575",
    width: 32,
    height: 32,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  patientName: {
    ...theme.typography.h5,
    color: theme.palette.text.primary,
  },
  statusContainer: {
    display: "flex",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  activeChip: {
    backgroundColor: "#e8f5e8",
    color: "#4caf50",
    fontWeight: 500,
    border: "1px solid #81c784",
  },
  addPrescriptionButton: {
    backgroundColor: "#2196f3",
    color: "white",
    textTransform: "none",
    borderRadius: theme.spacing(3),
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    "&:hover": {
      backgroundColor: "#1976d2",
    },
  },
  sectionTitle: {
    ...theme.typography.h6,
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  infoGrid: {
    "& .MuiGrid-item": {
      paddingBottom: theme.spacing(2),
    },
  },
  infoLabel: {
    ...theme.typography.subtitle1,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
  infoValue: {
    ...theme.typography.body1,
    color: theme.palette.text.primary,
  },

  tabsContainer: {
    margin: theme.spacing(2),
    marginTop: 0,
  },
  tabList: {
    backgroundColor: "#f5f5f5",
    borderRadius: theme.spacing(4),
    padding: theme.spacing(0.5),
    minHeight: "auto",
    display: "inline-flex",
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& .MuiTabs-flexContainer": {
      gap: theme.spacing(0.5),
    },
  },
  tab: {
    fontFamily:
      '"Euclid Circular B", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "0.875rem",
    lineHeight: 1,
    letterSpacing: "0em",

    textTransform: "none",
    minHeight: 36,
    borderRadius: "20px",
    color: "#444",
    backgroundColor: "#fff",
    border: "1px solid #d1d1d1",
    padding: `${theme.spacing(0.75)}px ${theme.spacing(2)}px`,
    minWidth: "auto",
    transition: "all 0.2s ease",

    "&.Mui-selected": {
      backgroundColor: "#e3f2fd",
      border: "1px solid #2196f3",
      color: "#1B56FD",
      fontWeight: 600,
    },
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },

  tabPanel: {
    padding: theme.spacing(3, 0, 0, 0),
  },
  tabContent: {
    backgroundColor: "white",
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3),
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    minHeight: "400px",
  },
  activeTab: {
    backgroundColor: "#1162FE",
    color: "white",
    "&:hover": {
      backgroundColor: "#1976d2",
    },
  },
  tabPanels: {
    padding: 0,
  },
  noContentContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px",
  },
  noLabel: {
    color: "#999",
    fontSize: "16px",
  },
  tabListBottom: {
    backgroundColor: "#f4f6f8",
    borderRadius: "12px",
    padding: theme.spacing(0.5),
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
  tabBottom: {
    fontFamily:
      '"Euclid Circular B", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: "0.875rem",
    lineHeight: 1,
    letterSpacing: "0em",
    textTransform: "none",
    minHeight: 38,
    borderRadius: "10px",
    color: theme.palette.text.secondary,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    minWidth: 140,
    height: 38,
    transition: "all 0.2s ease",

    "&:hover": {
      backgroundColor: "rgba(17, 98, 254, 0.08)",
      color: theme.palette.text.primary,
    },

    "&.Mui-selected": {
      backgroundColor: "#1162FE",
      color: "white",
      fontWeight: 600,
      boxShadow: "0 2px 6px rgba(17, 98, 254, 0.35)",
    },
  },

  symptomTable: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: theme.spacing(4),
  },
  tableHeader: {
    backgroundColor: "#f8f9fa",
    padding: theme.spacing(1.5),
    fontFamily:
      '"Euclid Circular B", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "0.875rem",
    lineHeight: 1,
    letterSpacing: "0em",
    color: "#666",
    textAlign: "left",
    borderBottom: "1px solid #e0e0e0",
  },

  tableCell: {
    padding: theme.spacing(1.5),
    borderBottom: "1px solid #f0f0f0",
    fontSize: "0.875rem",
    verticalAlign: "middle",
  },
  symptomIcon: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    backgroundColor: "#e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
  },
  symptoms: {
    fontFamily: '"Euclid Circular B", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0",
    verticalAlign: "middle",
  },
  symptomRow: {
    display: "flex",
    alignItems: "center",
  },
  doshaChip: {
    padding: "4px 12px",
    borderRadius: "16px",
    fontSize: "0.75rem",
    fontWeight: 500,
  },
  vataChip: {
    backgroundColor: "#F7EEFF",
    color: "#6B4B8A",
    fontFamily: "Euclid Circular B, sans-serif",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "0",
    verticalAlign: "middle",
  },
  pittaChip: {
    backgroundColor: "#FFEAE7",
    color: "#EF6C57",
    fontFamily: "Euclid Circular B, sans-serif",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "0",
    verticalAlign: "middle",
  },
  kaphaChip: {
    backgroundColor: "#E7FFFA",
    color: "#3E8E7E",
    fontFamily: "Euclid Circular B, sans-serif",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "0",
    verticalAlign: "middle",
  },
  strotas: {
    fontFamily: '"Euclid Circular B", sans-serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "0",
    color: "#666",
    verticalAlign: "middle",
  },
  inference: {
    fontFamily: '"Euclid Circular B", sans-serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "0",
    color: "#666",
    verticalAlign: "middle",
  },
  vikrutiSection: {
    marginTop: theme.spacing(4),
  },
  vikrutiGrid: {
    gap: theme.spacing(3),
  },
  assessmentCard: {
    padding: theme.spacing(2),
    height: "400px",
  },
  assessmentTitle: {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: "#333",
    lineHeight: 1,
    verticalAlign: "middle",
    marginBottom: theme.spacing(1),
  },
  assessmentGrid: {
    gap: theme.spacing(1),
  },
  assessmentItem: {
    textAlign: "center",
    padding: theme.spacing(1),
    backgroundColor: "#f8f9fa",
    borderRadius: theme.spacing(1),
  },
  assessmentLabel: {
    fontFamily: "Euclid Circular B, sans-serif",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0",
    verticalAlign: "middle",
    color: "#666",
    marginBottom: theme.spacing(0.5),
  },

  assessmentValue: {
    fontFamily: "Euclid Circular B, sans-serif",
    fontWeight: 550,
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "100%",
    letterSpacing: "0",
    verticalAlign: "middle",
    color: "#333",
    marginBottom: "6px",
  },
  chartCard: {
    padding: theme.spacing(2),
    height: "400px",
  },
  // Vikruti Analysis / Risk Flags share the chart card, so the header carries a
  // segmented switch instead of a plain title when both datasets exist.
  panelToggle: {
    display: "flex",
    backgroundColor: "#f1f5f9",
    border: "1px solid #e6e8eb",
    borderRadius: 10,
    padding: 3,
  },
  panelToggleBtn: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.8rem",
    color: "#6b7280",
    borderRadius: 8,
    padding: "4px 12px",
    minWidth: 0,
    "&:hover": { backgroundColor: "rgba(17,98,254,0.06)" },
  },
  panelToggleBtnActive: {
    backgroundColor: "#fff",
    color: "#1B56FD",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    "&:hover": { backgroundColor: "#fff" },
  },
  riskPanel: {
    marginTop: theme.spacing(1.5),
    maxHeight: 320,
    overflowY: "auto",
    paddingRight: 4,
  },
  chartTitle: {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: "#333",
    lineHeight: 1,
    verticalAlign: "middle",
    marginBottom: theme.spacing(1),
  },
  chartSubtitle: {
    fontSize: "0.75rem",
    color: "#666",
    marginBottom: theme.spacing(2),
  },
  dayType: {
    fontSize: "0.875rem",
    width: 106,
    height: 36,
    opacity: 1,
    border: "0.5px solid #9AB4FF",
    background: "#EBF8FF",
    color: "#1B56FD",
  },

  hiContainer: {
    margin: theme.spacing(2),
    marginTop: 0,
  },
  hiTabList: {
    backgroundColor: "#ffffff",
    borderRadius: 12,
    border: "1px solid #eef0f3",
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
    minHeight: 52,
    "& .MuiTabs-flexContainer": {
      gap: theme.spacing(0.5),
    },
  },
  hiTab: {
    minHeight: 44,
    minWidth: 150,
    borderRadius: 10,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.9rem",
    color: theme.palette.text.secondary,
    transition: "all 0.2s ease",
    "& .MuiTab-wrapper": {
      flexDirection: "row",
      gap: theme.spacing(1),
      "& > *:first-child": {
        marginBottom: "0 !important",
        fontSize: "1.15rem",
      },
    },
    "&:hover": {
      backgroundColor: "rgba(17, 98, 254, 0.06)",
      color: theme.palette.text.primary,
    },
    "&.Mui-selected": {
      backgroundColor: "#1162FE",
      color: "#fff",
      boxShadow: "0 2px 6px rgba(17, 98, 254, 0.35)",
    },
  },
  hiPanel: {
    padding: 0,
  },
  hiSectionCard: {
    backgroundColor: "#ffffff",
    borderRadius: 14,
    border: "1px solid #eef0f3",
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.05)",
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
  },
  hiSectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    marginBottom: theme.spacing(1.75),
  },
  hiSectionDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: "#1162FE",
    flexShrink: 0,
  },
  hiSectionTitle: {
    fontSize: "1.05rem",
    fontWeight: 700,
    color: "#1f2937",
    flex: 1,
  },
  hiReadOnly: {
    fontSize: "0.68rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#6b7280",
    backgroundColor: "#f1f5f9",
    border: "1px solid #e6e8eb",
    borderRadius: 999,
    padding: "2px 10px",
  },
  hiPlaceholder: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    padding: theme.spacing(2),
    borderRadius: 12,
    border: "1px dashed #d6dae0",
    backgroundColor: "#fafbfc",
  },
  hiPlaceholderIcon: {
    color: "#9aa4b2",
    fontSize: "1.3rem",
    flexShrink: 0,
  },
  hiPlaceholderNote: {
    fontSize: "0.85rem",
    color: "#6b7280",
  },
  hiChatbotActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(1.5),
  },
  hiSaveBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 10,
    minWidth: 110,
  },
  hiEditIcon: {
    fontSize: "1.05rem",
    color: "#1162FE",
  },

  hiParamGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: theme.spacing(2.5),
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  hiParamRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    padding: theme.spacing(0.75, 1.25),
    borderRadius: 10,
    backgroundColor: "#f8fafc",
    border: "1px solid #eef0f3",
    borderLeft: "3px solid transparent",
    transition: "all 0.15s ease",
  },
  hiParamRowActive: {
    backgroundColor: "#eef4ff",
    borderColor: "#9ab4ff",
    borderLeftColor: "#1162FE",
    boxShadow: "0 1px 4px rgba(17, 98, 254, 0.1)",
  },
  hiParamIcon: {
    fontSize: "1.1rem",
    lineHeight: 1,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
  },
  hiParamCheck: {
    fontSize: "1.15rem",
    color: "#0a8f54",
  },
  hiParamLabel: {
    flex: 1,
    minWidth: 0,
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#374151",
  },
  hiParamLabelClickable: {
    cursor: "pointer",
    textDecoration: "underline",
    textDecorationStyle: "dotted",
    textUnderlineOffset: "3px",
    "&:hover": { color: "#1162FE" },
  },
  ampQuestion: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#374151",
    marginBottom: 6,
  },
  ampOptionLabel: {
    fontSize: "0.85rem",
    color: "#374151",
  },
  // Checklist rows carry the module's actual question under the short sign
  // label, so they stack one per row instead of flowing inline.
  ampCheckList: {
    display: "flex",
    flexDirection: "column",
  },
  ampCheckItem: {
    alignItems: "flex-start",
    marginLeft: -9,
    marginRight: 0,
    "& .MuiFormControlLabel-label": {
      paddingTop: 7,
    },
  },
  ampOptionQuestion: {
    display: "block",
    fontSize: "0.8rem",
    color: "#6b7280",
    marginTop: 2,
    lineHeight: 1.45,
  },
  ampCategoryTitle: {
    fontSize: "0.72rem",
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#9aa4b2",
    margin: theme.spacing(1.5, 0, 0.5),
  },
  ampEmptyNote: {
    fontSize: "0.8rem",
    color: "#8a6d3b",
    backgroundColor: "#fff8e6",
    border: "1px solid #f3e2b3",
    borderRadius: 8,
    padding: theme.spacing(1, 1.5),
    marginBottom: theme.spacing(2),
  },
  hiParamLabelActive: {
    color: "#1162FE",
  },
  hiParamControl: {
    width: 150,
    flexShrink: 0,
    backgroundColor: "#fff",
    borderRadius: 8,
  },
  // Read-only classification value — set by the questions/calculate flow, not
  // directly editable here.
  hiParamValue: {
    width: 150,
    flexShrink: 0,
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#1162FE",
    textAlign: "right",
  },
  hiParamValueEmpty: {
    width: 150,
    flexShrink: 0,
    fontSize: "0.85rem",
    fontStyle: "italic",
    color: "#9CA3AF",
    textAlign: "right",
  },

  hiOverviewGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
    gap: theme.spacing(1.25),
  },
  hiOverviewItem: {
    textAlign: "center",
    padding: theme.spacing(1.5, 1),
    borderRadius: 12,
    backgroundColor: "#f8fafc",
    border: "1px solid #eef0f3",
  },
  hiOverviewLabel: {
    fontSize: "0.78rem",
    color: "#6b7280",
    marginBottom: theme.spacing(0.5),
  },
  hiOverviewValue: {
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "#1f2937",
  },
  hiOverviewHint: {
    fontSize: "0.75rem",
    color: "#9aa4b2",
    fontStyle: "italic",
    marginTop: theme.spacing(1.25),
  },

  reportCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffffff",
    borderRadius: 12,
    border: "1px solid #eef0f3",
    boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
    padding: theme.spacing(2),
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      boxShadow: "0 4px 16px rgba(17,98,254,0.1)",
      borderColor: "#d6e0ff",
    },
  },
  reportCardHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
  },
  reportCardIcon: {
    width: 38,
    height: 38,
    borderRadius: 10,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": { fontSize: "1.3rem" },
  },
  reportCardTitle: {
    fontSize: "0.92rem",
    fontWeight: 700,
    color: "#1f2937",
    lineHeight: 1.25,
  },
  reportCardSubtitle: {
    fontSize: "0.78rem",
    color: "#6b7280",
    marginTop: theme.spacing(1),
    flex: 1,
  },
  reportCardActions: {
    display: "flex",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.75),
  },
  reportPreviewBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: "#1162FE",
    color: "#fff",
    boxShadow: "none",
    "&:hover": { backgroundColor: "#0d4fd1", boxShadow: "none" },
  },
  reportDownloadBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    borderColor: "#d1d9e6",
    color: "#374151",
    "&:hover": {
      borderColor: "#1162FE",
      backgroundColor: "rgba(17,98,254,0.06)",
    },
  },
  reportDialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2, 3),
  },
  reportDialogTitleText: {
    fontSize: "1.1rem",
    fontWeight: 700,
    color: "#1f2937",
  },
  nadiWrap: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
    padding: theme.spacing(1, 0),
  },
  nadiBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(0.75),
  },
  nadiBoxLabel: {
    fontSize: "0.9rem",
    fontWeight: 700,
    color: "#374151",
  },
  nadiInput: {
    width: 120,
    backgroundColor: "#fff",
    borderRadius: 8,
    "& input": {
      textAlign: "center",
      fontSize: "1.15rem",
      fontWeight: 600,
      color: "#1162FE",
    },
  },
  nadiSign: {
    fontSize: "1.6rem",
    fontWeight: 700,
    color: "#0a8f54",
    lineHeight: 1,
    paddingBottom: theme.spacing(0.75),
    minWidth: 20,
    textAlign: "center",
  },

  labFindingsWrap: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
  },
  labFindingRow: {
    display: "grid",
    gridTemplateColumns: "1.4fr 0.8fr 2fr 1.6fr",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: "#fdf5ec",
    border: "1px solid #f2e6d6",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr 1fr",
      rowGap: theme.spacing(1),
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  labFindingHead: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    minWidth: 0,
  },
  labFindingIcon: {
    fontSize: "1.4rem",
    flexShrink: 0,
  },
  labFindingTest: {
    fontSize: "0.92rem",
    fontWeight: 700,
    color: "#374151",
  },
  labFindingRange: {
    fontSize: "0.75rem",
    color: "#9aa4b2",
  },
  labFindingValueBox: {
    display: "flex",
    flexDirection: "column",
  },
  labFindingValue: {
    fontSize: "1.25rem",
    fontWeight: 700,
    lineHeight: 1.1,
  },
  labFindingStatus: {
    fontSize: "0.72rem",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
  labFindingMeaning: {
    fontSize: "0.85rem",
    color: "#4b5563",
    lineHeight: 1.4,
  },
  labFindingAyur: {
    fontSize: "0.85rem",
    fontStyle: "italic",
    fontWeight: 600,
    color: "#0a8f54",
    lineHeight: 1.4,
  },

  // --- Presenting Complaint (chatbot symptom_analyzer) ---
  pcWrap: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    height: "100%",
    overflowY: "auto",
  },
  pcPrimary: {
    fontSize: "1.05rem",
    fontWeight: 700,
    color: "#1f2937",
    lineHeight: 1.3,
  },
  pcMetaRow: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "baseline",
  },
  pcMetaLabel: {
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#6b7280",
    minWidth: 66,
    flexShrink: 0,
  },
  pcMetaValue: {
    fontSize: "0.85rem",
    color: "#374151",
  },

  // --- Chatbot text sections (assessment summary / home remedies) ---
  cbLead: {
    fontSize: "0.9rem",
    color: "#374151",
    lineHeight: 1.55,
    marginBottom: theme.spacing(1.5),
  },
  cbBlock: {
    marginTop: theme.spacing(1.5),
  },
  cbBlockTitle: {
    fontSize: "0.8rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#1162FE",
    marginBottom: theme.spacing(0.75),
  },
  cbBlockText: {
    fontSize: "0.88rem",
    color: "#374151",
    lineHeight: 1.5,
  },
  cbList: {
    margin: 0,
    paddingLeft: theme.spacing(2.5),
    "& li": {
      fontSize: "0.88rem",
      color: "#374151",
      lineHeight: 1.5,
      marginBottom: theme.spacing(0.5),
    },
  },
  cbChip: {
    display: "inline-block",
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#0a8f54",
    backgroundColor: "#e7fff5",
    border: "1px solid #bdead9",
    borderRadius: 999,
    padding: "3px 12px",
  },
  cbRemedyList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
  },
  cbRemedyCard: {
    borderRadius: 12,
    border: "1px solid #f2e6d6",
    backgroundColor: "#fdf5ec",
    padding: theme.spacing(2),
  },
  cbRemedyDate: {
    fontSize: "0.75rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#a37c4b",
    marginBottom: theme.spacing(1),
  },

  // --- Report highlights (deranged values / priority findings above the PDF) ---
  hlWrap: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  hlHeaderRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    flexWrap: "wrap",
  },
  hlBadge: {
    fontSize: "0.75rem",
    fontWeight: 700,
    borderRadius: 999,
    padding: "4px 12px",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    color: "#fff",
  },
  hlHeadline: {
    fontSize: "0.95rem",
    fontWeight: 600,
    color: "#374151",
    lineHeight: 1.4,
  },
  hlSummary: {
    fontSize: "0.88rem",
    color: "#4b5563",
    lineHeight: 1.5,
  },
  hlBlockTitle: {
    fontSize: "0.78rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#6b7280",
    marginBottom: theme.spacing(1),
  },
  hlConcernRow: {
    display: "flex",
    gap: theme.spacing(1.25),
    alignItems: "flex-start",
    padding: theme.spacing(1.25, 1.5),
    borderRadius: 10,
    backgroundColor: "#fdf7f5",
    border: "1px solid #f0ddd8",
    marginBottom: theme.spacing(1),
  },
  hlRowIcon: {
    fontSize: "1.15rem",
    flexShrink: 0,
    marginTop: 2,
  },
  hlRowMain: {
    minWidth: 0,
    flex: 1,
  },
  hlRowTitle: {
    fontSize: "0.9rem",
    fontWeight: 700,
    color: "#374151",
  },
  hlRowSub: {
    fontSize: "0.82rem",
    color: "#6b7280",
    lineHeight: 1.45,
    marginTop: 2,
  },
  hlRowTag: {
    fontSize: "0.72rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  hlChipWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  hlChip: {
    fontSize: "0.8rem",
    fontWeight: 600,
    borderRadius: 999,
    padding: "4px 12px",
    backgroundColor: "#fdf7f5",
    color: "#b23b2e",
    border: "1px solid #f0ddd8",
  },
  hlChipNeutral: {
    fontSize: "0.8rem",
    fontWeight: 600,
    borderRadius: 999,
    padding: "4px 12px",
    backgroundColor: "#f1f5f9",
    color: "#475569",
    border: "1px solid #e2e8f0",
  },
  hlKvRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    padding: theme.spacing(1, 1.25),
    borderRadius: 8,
    backgroundColor: "#f8fafc",
    border: "1px solid #eef0f3",
    marginBottom: theme.spacing(0.75),
  },
  hlKvLabel: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#374151",
  },
  hlKvValue: {
    fontSize: "0.85rem",
    color: "#6b7280",
    textAlign: "right",
  },
  hlDoshaRow: {
    display: "grid",
    gridTemplateColumns: "64px 1fr 116px",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  hlDoshaLabel: {
    fontSize: "0.85rem",
    fontWeight: 700,
    color: "#374151",
  },
  hlDoshaTrack: {
    position: "relative",
    height: 8,
    borderRadius: 999,
    backgroundColor: "#eef0f3",
    overflow: "hidden",
  },
  hlDoshaFill: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    borderRadius: 999,
  },
  hlDoshaVal: {
    fontSize: "0.78rem",
    fontWeight: 700,
    textAlign: "right",
  },
  hlDivider: {
    border: "none",
    borderTop: "1px solid #eef0f3",
    margin: theme.spacing(1, 0, 0.5),
  },
  hlFullBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    borderColor: "#d1d9e6",
    color: "#374151",
    "&:hover": {
      borderColor: "#1162FE",
      backgroundColor: "rgba(17,98,254,0.06)",
    },
  },
}));

export default useCommonStyles;
